/**
 * GraphQL queries and hooks — supplier pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { TechnologySupplier } from '../types/supplier';

const LIST_SUPPLIERS = gql`
  query ListSuppliers {
    suppliers {
      entityId
      entityType
      name
      description
      websiteUrl
      tags
      technologyProductCount
      _schemaVersion
      _createdAt
      _createdBy
      _updatedAt
      _updatedBy
    }
  }
`;

export function useSuppliers(): QueryResult<{ suppliers: TechnologySupplier[] }> {
  return useQuery(LIST_SUPPLIERS, { fetchPolicy: 'network-only', nextFetchPolicy: 'cache-first' });
}
